import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    children: [

      {
        path: '',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
      },

      {
        path: '',
        loadChildren: () => import('./student/student.module').then(m => m.StudentModule)
      },
      {
        path: '',
        loadChildren: () => import('./theme/theme.module').then(m => m.ThemeModule)
      },


    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FullPagesRoutingModule { }
